import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import checkPaginationNav from '@/libs/checkPaginationNav';

@Component({
    name: 'Pagination'
})
export default class Pagination extends Vue {
    @Prop(Number)
    totalItems!: number;

    @Prop(Number)
    currentPage!: number;

    @Prop(Number)
    limit?: number;

    private get totalRows() {
        return this.totalItems;
    }

    private get limitCount() {
        return this.limit ? this.limit : 30;
    }

    private get showPagination() {
        if(this.totalItems){
            return checkPaginationNav(this.totalItems, this.limitCount)
        }
    }

    private onChangePage(newPage:number) {
        this.$emit('currentPage', newPage);
    }
}
